<app-nav></app-nav>


<section class="terms-item ">
    <div class="container">
        <div class="row">
            <div class="col col-md-2"></div>
            <div class="col-12 col-md-10">
                <a name="legal_tad" class="terms-item-link"></a>
                <h2>The Terms and Conditions</h2>

                <h3>1. The terms and conditions</h3>

                <p>The following are the Terms and Conditions (the &quot;Agreement&quot;) which govern your access and
                    use of our online Platform through which information service aims to inform you on your level of
                    anxiety may be provided (collectively the &quot;Platform&quot;).</p>

                <p>This website is owned and operated by Steel Blanket Technologies s.r.o., address: square I. P.
                    Pavlova 1785/3, New Town, 120 00 Prague 2, (steelblanket.info@gmail.com).</p>

                <p>Website visitor, individual or entity who uses the Platform, including a user registered using a
                    Google profile or creating an account, is referred to as &quot;you&quot; or &quot;Visitor.&quot;</p>

                <p>The Platform is offered and made available to Visitors who are eighteen (18) &nbsp;years of age or
                    older.</p>

                <p>By accessing or using the Platform, you are entering into this Agreement. You should read this
                    Agreement carefully before starting to use the Platform. If you disagree to be bound to any term of
                    this Agreement, you must not access the Platform.</p>

                <p>When the terms &quot;we,&quot; &quot;us,&quot; &quot;our,&quot; or similar are used in this
                    Agreement, they refer to the Company that owns and operates the Platform (the
                    &quot;Company&quot;).</p>

                <h3>2. The Counselors and Counselor Services</h3>

                <p>The Platform allows Visitors to take services, such as testing the level of anxiety.</p>

                <p>The Platform may be used to inform you about your level of anxiety or the existence of post-traumatic
                    syndromes.</p>

                <p>You understand and agree that the Company is not a medical institution or medical health provider. We
                    do not provide professional services by medical institutions or medical health providers.</p>

                <p>The Platform does not provide medical advice. All medically related information, including, without
                    limitation, text messages, is for informational purposes only. This information does not replace
                    professional medical advice, diagnosis, or treatment. If you have questions about a medical
                    condition, always seek the advice of a doctor or other qualified health professional.</p>

                <p>The information available on and through the Platform is a supplement to, and NOT a substitute for,
                    the knowledge, skill, and judgment of qualified psychiatrists, psychologists, physicians, and health
                    care professionals. The information on the Platform has been obtained from sources believed to be
                    qualified, accurate, and reliable. However, Company makes no warranty on this information&#39;s
                    accuracy, reliability, or completeness. Please consult a physician or other health care professional
                    if you have health, medical, or disability questions or concerns. Information accessed on or through
                    the Platform is neither complete nor exhaustive and does not cover all mental resources, illnesses,
                    and/or conditions or their management or treatment. Information accessed on and through Platform is
                    provided &quot;AS IS&quot; and without warranty, express or implied, including, but not limited to,
                    any implied warranty of fitness for a particular purpose.</p>

                <p><i>IF YOU ARE THINKING ABOUT SUICIDE OR CONSIDERING HARMING YOURSELF OR OTHERS, IF YOU FEEL ANY OTHER
                    PERSON MAY BE IN ANY DANGER, OR IF YOU HAVE ANY MEDICAL EMERGENCY, YOU MUST IMMEDIATELY CALL THE
                    EMERGENCY SERVICE NUMBER (911) AND NOTIFY THE RELEVANT AUTHORITIES. SEEK IMMEDIATE IN-PERSON
                    ASSISTANCE. THE PLATFORM IS NOT DESIGNED FOR USE IN ANY OF THE MENTIONED ABOVE, AND THE COUNSELORS
                    CAN NOT PROVIDE THE ASSISTANCE REQUIRED IN ANY OF THE CASES MENTIONED ABOVE. THE PLATFORM IS NOT
                    INTENDED FOR THE PROVISION OF CLINICAL DIAGNOSIS REQUIRING AN IN-PERSON EVALUATION, AND YOU SHOULD
                    NOT USE IT IF YOU NEED ANY OFFICIAL DOCUMENTATION OR APPROVALS FOR PURPOSES SUCH AS, BUT NOT LIMITED
                    TO, COURT-ORDERED COUNSELING. IT IS ALSO NOT INTENDED FOR ANY INFORMATION REGARDING WHICH DRUGS OR
                    MEDICAL TREATMENT MAY BE APPROPRIATE FOR YOU, AND YOU SHOULD DISREGARD ANY SUCH ADVICE IF DELIVERED
                    THROUGH THE PLATFORM. DO NOT DISREGARD, AVOID, OR DELAY IN OBTAINING IN-PERSON CARE FROM YOUR DOCTOR
                    OR OTHER QUALIFIED PROFESSIONAL BECAUSE OF THE INFORMATION OR ADVICE YOU RECEIVED THROUGH THE
                    PLATFORM.</i></p>

                <h3>3. Privacy and Security</h3>

                <p>Protecting and safeguarding any information you provide through the Platform is extremely important
                    to us.</p>

                <p><i>BY AGREEING TO THIS AGREEMENT AND/OR USING THE PLATFORM, YOU ALSO AGREE TO THE PRIVACY POLICY
                    TERMS. THE PRIVACY POLICY IS INCORPORATED INTO AND DEEMED A PART OF THIS AGREEMENT. THE SAME RULES
                    APPLY REGARDING CHANGES AND REVISIONS OF THIS AGREEMENT AND APPLY TO CHANGES AND REVISIONS OF THE
                    PRIVACY POLICY.</i></p>

                <h3>4. Disclaimer of Warranty and Limitation of Liability</h3>

                <p><i>YOU HEREBY RELEASE US AND AGREE TO HOLD US HARMLESS FROM ANY AND ALL CAUSES OF ACTION AND CLAIMS
                    OF ANY NATURE RESULTING FROM THE COUNSELOR&#39;S SERVICES OR THE PLATFORM, INCLUDING (WITHOUT
                    LIMITATION) ANY ACT, OMISSION, OPINION, RESPONSE, ADVICE, SUGGESTION, INFORMATION AND/OR SERVICE OF
                    ANY COUNSELOR AND/OR ANY OTHER CONTENT OR INFORMATION ACCESSIBLE THROUGH THE PLATFORM. </i></p>

                <p><i>YOU UNDERSTAND, AGREE, AND ACKNOWLEDGE THAT THE PLATFORM IS PROVIDED &quot;AS IS&quot; WITHOUT ANY
                    EXPRESS OR IMPLIED WARRANTIES OF ANY KIND, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY,
                    NON-INFRINGEMENT, SECURITY, FITNESS FOR A PARTICULAR PURPOSE, OR ACCURACY. THE USE OF THE PLATFORM
                    IS AT YOUR OWN RISK. TO THE FULLEST EXTENT OF THE LAW, WE EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY
                    KIND, WHETHER EXPRESSED OR IMPLIED. YOU UNDERSTAND, AGREE, AND ACKNOWLEDGE THAT WE SHALL NOT BE
                    LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR
                    EXEMPLARY DAMAGES. Suppose</i> the applicable law does not allow the limitation of liability as set
                    forth above. In that case, the limitation will be modified solely to the extent necessary to comply
                    with the applicable law. This section shall survive the termination or expiration of this Agreement.
                </p>

                <p><i>CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES. IF THESE LAWS APPLY TO YOU,
                    SOME OR ALL OF THE FOREGOING DISCLAIMERS, EXCLUSIONS, AND LIMITATIONS MAY NOT APPLY TO YOU, AND YOU
                    MIGHT HAVE ADDITIONAL RIGHTS.</i></p>

                <h3>5. Your account, representations, conduct, and commitments</h3>

                <p>When you create an account to use or access certain portions of the Platform, you must provide
                    complete and accurate information as requested on the registration form. You must maintain and
                    update such information to keep it complete and accurate. You will also be asked to provide a user
                    name, email, and password. You are responsible for maintaining your password&#39;s confidentiality
                    and for all activities (whether by you or others) that occur under your password or account. You may
                    not use a third party&#39;s account, user name, or password at any time, and you will not allow
                    anyone to access or use the Platform from your account.</p>

                <p>You hereby represent and warrant to the Company that: (a) you have all requisite rights and authority
                    to use the Platform under this Agreement and to grant all applicable rights herein; (b) you are
                    responsible for all use of the Platform associated with its account; (c) you are solely responsible
                    for maintaining the confidentiality of its account names, emails and password(s); (d) you agree to
                    immediately notify the Company of any unauthorized use of your account of which you becomes aware;
                    (e) you agree that the Company will not be liable for any losses incurred as a result of a third
                    party&#39;s use of your account, regardless of whether such use is with or without your knowledge
                    and consent; (f) you will use the Platform for lawful purposes only and subject to this Agreement;
                    (g) any information you submit through Platform is true, accurate, and correct; and (h) you will not
                    attempt to gain unauthorized access to the Platform, other accounts, computer systems, or networks
                    under the control or responsibility of the Company through hacking, cracking, password mining, or
                    any other unauthorized means.</p>

                <p>You hereby confirm that you can legally consent to receive Services or have the consent of a parent
                    or guardian and that you can legally enter into a contract. You hereby confirm and agree that all
                    the information you provided in or through the Platform, and the information you will provide in or
                    through the Platform in the future, is accurate, true, current, and complete. Furthermore, you agree
                    that during this Agreement, you will make sure to maintain and update this information so it will
                    continue to be accurate, current, and complete. You agree, confirm and acknowledge that you are
                    responsible for maintaining the confidentiality of your password and any other security information
                    related to your account (collectively &quot;Account Access&quot;). We advise you to change your
                    password frequently and to take extra care in safeguarding your password. You agree to notify us
                    immediately of any unauthorized use of your Account Access or any other concern for breach of your
                    account security. You agree, confirm and acknowledge that we will not be liable for any loss or
                    damage incurred from someone else using your account, either with or without your consent and/or
                    knowledge. You agree, confirm and acknowledge that you are solely and entirely liable and
                    responsible for all activities performed using your Account Access. You further acknowledge and
                    agree that we will hold you liable and responsible for any damage or loss incurred from using your
                    Account Access by any person, whether authorized by you or not, and you agree to indemnify us for
                    any such damage or loss. You agree and commit not to use any other person&#39;s account or account
                    access for any reason. You agree and confirm your use of the Platform. You agree and commit not to
                    interfere with or disrupt, or attempt to interfere with or disrupt, any of our systems, services,
                    servers, networks, or infrastructure, or any of the Platform&#39;s systems, services, servers,
                    networks, or infrastructure, including without limitation obtaining unauthorized access to those
                    mentioned above. You agree and commit not to make any use of the Platform for the posting, sending,
                    or delivery of either of the following:</p>

                <ol start="1" style="margin-top:0cm" type="1">
                    <li>Unsolicited email and/or advertisement or promotion of goods and services.</li>
                    <li>Malicious software or code.</li>
                    <li>Unlawful, harassing, privacy invading, abusive, threatening, vulgar, obscene, racist, or
                        potentially harmful content.
                    </li>
                    <li>Any content infringes a third party&#39;s right, including intellectual property rights.</li>
                    <li>Any content that may cause damage to a third party.</li>
                    <li>Any content which may constitute, induce or encourage a criminal action or violate any
                        applicable law.
                    </li>
                </ol>

                <p>You agree and commit not to violate any applicable local, state, national or international law,
                    statute, ordinance, rule, regulation, or ethical code concerning your use of the Platform. You will
                    indemnify us, defend us, and hold us harmless from and against all claims, losses, causes of action,
                    demands, liabilities, costs, or expenses (including, but not limited to, litigation and reasonable
                    attorneys&#39; fees and expenses) arising out of or relating to any of the following:</p>

                <ol start="1" style="margin-top:0cm" type="1">
                    <li>Your access to or use of the Platform.</li>
                    <li>Any actions are made with your account or account access, whether by you or someone else.</li>
                    <li>Your violation of any of the provisions of this Agreement.</li>
                    <li>Non-payment for any of the services (including Counselor Services) which were provided through
                        the Platform.
                    </li>
                    <li>You violate any third party right, including, without limitation, any intellectual property
                        right, publicity, confidentiality, property, or privacy right.
                    </li>
                </ol>

                <h3>6. Modifications, Termination, Interruption, and Disruptions to the Platform.&nbsp;&nbsp;&nbsp;</h3>

                <p>You understand, agree, and acknowledge that we may modify, suspend, disrupt or discontinue the
                    Platform, any part of the Platform, or the use of the Platform, whether to all clients or you
                    specifically, at any time with or without notice to you. You agree and acknowledge that we will not
                    be liable to you or any third party for any actions mentioned above or any modification, suspension,
                    or discontinuance of the Counselor Services for any losses or damages caused by any of the
                    activities mentioned above. The Platform depends on various factors such as software, hardware, and
                    tools, either our own or those owned and/or operated by our contractors and suppliers. While we make
                    commercially reasonable efforts to ensure the Platform&#39;s reliability and accessibility, you
                    understand and agree that no platform can be 100% reliable and accessible. So we cannot guarantee
                    that access to the Platform will be uninterrupted or that it will be accessible, consistent, timely,
                    or error-free at all times.</p>

                <h3>7. Notices</h3>

                <p>We may provide notices or other communications to you regarding this Agreement or any aspect of the
                    Platform by emailing the email address we have on record, by regular mail, or by posting it online.
                    The date of receipt shall be deemed the date on which such notice is given. Notices sent to us must
                    be delivered by email to questions@anima.help</p>

                <h3>8. Important notes about our Agreement</h3>

                <p>This Agreement and any dispute that might arise between you and the Company will be interpreted
                    solely under the laws of the State of California and the United States of America without regard to
                    any conflict of law or other principles that provide for the application of the law of another
                    jurisdiction. <i>THIS AGREEMENT CONSTITUTES THE ENTIRE AGREEMENT BETWEEN YOU AND US. YOU CONFIRM
                        THAT YOU HAVE NOT RELIED UPON ANY PROMISES OR REPRESENTATIONS BY US EXCEPT AS OUTLINED IN THIS
                        AGREEMENT. </i>We may change this Agreement by posting modifications on the Platform. Unless
                    otherwise specified by us, all modifications shall be effective upon posting. Therefore, you are
                    encouraged to check the terms of this Agreement frequently. The last update date of this Agreement
                    is posted at the bottom of the Agreement. You agree to be bound by such changes to the Agreement by
                    using the Platform after the changes become effective. If you do not agree to the changes, you must
                    terminate the Platform&#39;s access and participation in its services. We may freely transfer or
                    assign this Agreement or any of its obligations hereunder. The paragraph headings in this Agreement
                    are solely for convenience and will not be applied in interpreting this Agreement. Suppose any
                    provision of this Agreement is held by a court of competent jurisdiction to be illegal, invalid,
                    unenforceable, or otherwise contrary to law. In that case, the remaining provisions of this
                    Agreement will remain in full force and effect. To clear any doubt, all clauses regarding
                    limitations of liabilities and indemnification shall survive the termination or expiration of this
                    Agreement.</p>

                <h3>9. Intellectual Property Rights</h3>

                <p>The Platform contains proprietary materials and is protected by copyright laws, international treaty
                    provisions, trademarks, service marks, and other intellectual property laws and treaties. Except as
                    otherwise expressly provided by rights holders, none of the Platform may be copied, reproduced,
                    republished, downloaded, uploaded, posted, displayed, transmitted, or distributed. NOTHING ON THE
                    PLATFORM SHALL BE CONSTRUED TO CONFER ANY LICENSE UNDER ANY OF THE RIGHTS HOLDER&#39;S INTELLECTUAL
                    PROPERTY RIGHTS, WHETHER BY ESTOPPEL, IMPLICATION, OR OTHERWISE.</p>

                <p>Upon your acceptance of this Agreement, we grant you to access and right to use the Platform for your
                    internal purposes and only as expressly permitted. You shall not use or permit the use of the
                    Platform for any illegal purpose or in any manner inconsistent with the provisions of this
                    Agreement.</p>

                <p>You acknowledge that, except as described in this Agreement, the information you provide to us or
                    that we collect will be used and protected as described in the Privacy Policy below.</p>

                <a name="legal_pp" class="terms-item-link"></a>
                <h2>Privacy Policy</h2>

                <h3>1. About Your Privacy and This Privacy Policy</h3>

                <p>Your privacy is critical to us. We constantly put much thought, effort, tools, resources, and
                    procedures in place to protect and safeguard your privacy. This document is our &quot;Privacy
                    Policy,&quot; and it contains details on issues related to your privacy when using our services.
                    This Privacy Policy applies to visitors to the public websites owned and operated by Company, the
                    registered users of the Platform. It is intended to inform you of our policies, procedures, and
                    practices regarding the collection, use, and disclosure of any information that you provide through
                    the Platform. The Privacy Policy is part of our Terms and Conditions. The terms in the Privacy
                    Policy (such as but not limited to &quot;we,&quot; &quot;our,&quot; &quot;us,&quot; &quot;Platform,&quot;
                    and &quot;Counselor Services&quot;) have the same meaning as in our Terms and Conditions document.
                    When you use our Platform, you accept and agree to the Terms and Conditions and the Privacy Policy.
                    If you disagree with being bound to the Privacy Policy, you should stop using the Platform
                    immediately. By accessing and using our Platform, as applicable, you affirm that you have read the
                    Terms and Conditions and the Privacy Policy and that you understand, agree to, and acknowledge all
                    the terms contained in both.</p>

                <h3>2. Information Collection, Use, and Disclosure</h3>

                <h3>Categories of Information Collected</h3>

                <p>To let us operate the Platform effectively and to let you use the Platform, we may collect, use, and
                    store the information described below. We also disclose certain information to third parties, as
                    described further below. The information we collect is received directly or indirectly from you and
                    generated during your use of the Platform. We also collect information generated as you use our
                    services and information from third parties, like when you access our services through your Facebook
                    login or your Google Login. The data we collect is not used for marketing or other purposes except
                    as specified in this Privacy Policy.&nbsp;</p>

                <p><b>Visitor Data:</b> Company collects, uses, and stores data regarding user visits to its website and
                    use of the the Platform (&quot;Visitor Data&quot;), including the particular pages visited or viewed
                    by the user, the amount of time the user spent on the website, website errors experienced by the
                    user, visits the &nbsp;&quot;FAQ&quot; page, and information about the browser or device used to
                    access the website, such as the user&#39;s device ID and IP address.</p>

                <p><b>Onboarding Data:</b> In addition to the information provided by users through the Platform,
                    Company collects, uses, and stores specific additional data from users during the onboarding process
                    (&quot;Onboarding Data&quot;). This data includes the pages viewed by the user and whether the user
                    clicks the &quot;Get started&quot; link to begin the test.</p>

                <p><b>Account Registration Data:</b> Company collects, uses, and stores certain information in
                    connection with the account registration process, such as whether users registered using their
                    Google profiles and whether a user verifies their reported email address or phone number (&quot;Account
                    Registration Data&#39;&#39;). Company also assigns each user who creates an &nbsp;account an
                    anonymized, sequentially-generated client ID.</p>

                <p><b>Transaction Data:</b> Company collects, uses, and stores certain information regarding payment for
                    its services by users and related transactions on its website, such as whether a user completed
                    payment for services, signed up for &nbsp;services using a trial offer, canceled or otherwise ended
                    a trial, or completed a request to receive financial aid for &nbsp;services (&quot;Transaction Data&quot;).
                </p>

                <p><b>Login Data:</b> Company collects, uses, and stores data regarding logins to Platform by registered
                    users and activity conducted during that login, such as when a user logs in, the number of messages
                    received or sent through Platform during that login, and whether a user has been assigned, started,
                    or completed a counseling goal (&quot;Login Data&quot;). Login Data does not include the content of
                    any messages sent or received by users or the content of any counseling goals.</p>

                <p><b>Customer Data:</b> Company collects, uses, and stores specific data from users that have signed up
                    for services, such as a user&#39;s self-reported name or nickname, age, email address, phone number,
                    and emergency contact information (&quot;Customer Data&quot;).</p>

                <p><b>Communications Data:</b> Company collects, uses, and stores communications between users and
                    specialists on the Platform and between users and Company&#39;s customer service team (&quot;Communications
                    Data&quot;). Protecting this information is crucial for us. Other than in the ways detailed in this
                    Privacy Policy, we will never use or disclose any information unless you request or approve us.
                    Purposes for Which Information Is Used We may use the information we collect for one or more of the
                    following purposes:</p>

                <h3>Communication with you</h3>

                <ul>
                    <li>To contact you or provide information, alerts, and suggestions related to the Platform.</li>
                    <li>To verify your identity.</li>
                    <li>To complete an activity you requested, such as register for the Platform or obtain more
                        information.
                    </li>
                    <li>To reach out to you, either ourselves or using the appropriate authorities, if we have a good
                        reason to believe that you or any other person may be in danger or may be either the cause or
                        the victim of a criminal act.
                    </li>
                </ul>

                <h3>Delivery of services to you</h3>

                <ul>
                    <li>To create your account on our Platform and let you log in to your account and use the
                        Platform.
                    </li>
                    <li>To manage your account, provide customer support, and ensure you receive quality service.</li>
                    <li>For billing and transaction processing purposes.</li>
                    <li>To provide, support, personalize, and develop our Platform.</li>
                </ul>

                <h3>Administration and improvement of services</h3>

                <ul>
                    <li>To supervise, administer and monitor the Platform.</li>
                    <li>To measure and improve our services&#39; quality, effectiveness, and delivery.</li>
                </ul>

                <h3>Customization</h3>

                <ul>
                    <li>Personalize the website experience and deliver content and product and service offerings
                        relevant to individual interests, including targeted offers and ads.
                    </li>
                </ul>

                <h3>Compliance with the law</h3>

                <ul>
                    <li>Respond to law enforcement requests as required by applicable law, court order, or governmental
                        regulations.
                    </li>
                    <li>To comply with applicable state and federal laws, including but not limited to laws related to
                        protecting client and public health and safety.
                    </li>
                    <li>To allow therapists to comply with their jurisdictions&#39; licensure, legal, and quality
                        requirements.
                    </li>
                </ul>

                <h3>Other uses with consent</h3>

                <ul>
                    <li>Any other purpose with your consent.</li>
                </ul>

                <h3>Purposes for Which Information Is Disclosed to Third Parties</h3>

                <p>Information about you may be disclosed to third parties for one or more of the following
                    purposes:</p>

                <p><strong>For business purposes:</strong> We may share your information with vendors and service
                    providers, including our data hosting and storage partners, analytics and vendors providing
                    technology services and support, payment processing, and data security. We also may share
                    information with professional advisers, such as auditors, law firms, and accounting firms.</p>

                <p>With your direction or consent: We may share your information with third parties if you request or
                    direct us.</p>

                <p>With affiliates within our corporate group: We may share your information with any subsidiaries or
                    parent companies within our corporate group.</p>

                <p><strong>For advertising:</strong> If you are opt-in to the use of targeting cookies and web beacons,
                    information regarding your activity on our websites, excluding activity when you are logged in and
                    have started therapy, may be disclosed to our advertising partners to optimize marketing. We do not
                    share with any advertising platform private information like member names, email addresses, phone
                    numbers, diagnosis, session data, journal entries, messages, worksheets, or any other type of
                    communication you have with your therapist if you want to opt-out of these cookies and web beacons.&nbsp;
                </p>

                <p><b>Compliance with law:</b> We may share your information with a court, a regulatory entity, law
                    enforcement personnel, or under a subpoena to comply with applicable law or any obligations
                    thereunder.</p>

                <p><strong>In the context of a transaction:</strong> We may share your information in connection with an
                    asset sale, merger, bankruptcy, or other business transaction.</p>

                <p>For other business reasons: We may share your information to enforce any applicable Terms and
                    Conditions and Terms and Conditions and to ensure the safety and security of the Platform and our
                    users. Note that if you make any information publicly available on the Platform, anyone may see and
                    use such information.</p>

                <h3>3. Opting-out of Marketing Communication</h3>

                <p>You can opt out of receiving email marketing by using the unsubscribe link in our marketing email
                    communications.</p>

                <a name="cookies" class=""></a>
                <h3>4. Cookies and Web Beacons</h3>

                <p>Like many websites, we use &quot;cookies&quot; and &quot;web beacons&quot; (also known as pixels) to
                    collect information. A &quot;cookie&quot; is a small data file transferred to your computer&#39;s
                    hard disk for record-keeping purposes. We collect cookies necessary for the Platform to function,
                    cookies that enhance the Platform&#39;s performance, and cookies used for third-party tracking. A
                    &quot;web beacon&quot; is a small and sometimes invisible image or embedded code placed on a Web
                    page or email that can report your visit or use to a third party. Web beacons are typically used by
                    third parties to monitor the activity of users at a website for web analytics, advertising
                    optimization, or page tagging. Additional information regarding web beacons is available on
                    Wikipedia. You can change your browser&#39;s settings to stop accepting cookies and web beacons or
                    prompt you before accepting a cookie or web beacon. Use of Cookies, Web Beacons, and Similar
                    Technology for analytics We may use third-party cookies or web beacons for web analytics,
                    attribution, and error management. Our Platform may use vendor services that use cookies, web
                    beacons, and similar technology to collect and store anonymous information about you, including when
                    you pay for services, load a page, indicate that you heard about us on television, sign up for
                    services, enter your payment information (but the payment details are not disclosed), start the
                    intake questionnaire, and your response as to the referral source to the Platform. Our Platform also
                    uses analytics vendors to collect information (for example, Visitor Data and Onboarding Data) about
                    user actions on our websites for analytics and analysis of specific Platform usage. Use of Cookies,
                    Web Beacons, and Similar Technology for Advertising Networks If you are opt-in to targeting cookies
                    and web beacons, you and others may see certain ads for our services or the Platform on other
                    websites because we participate in ad networks. Ad networks allow us to target our messaging to
                    users through demographic, interest-based, and contextual means. Over time, these networks track
                    individuals&#39; online activities by collecting information through automated means, including
                    cookies, web server logs, and web beacons. The networks use this information to show advertisements
                    that may be tailored to an individual&#39;s interests. Our ad networks may collect information about
                    your visits to websites that participate in the relevant ad networks, such as the pages or
                    advertisements you view and the actions you take on the websites. This data collection takes place
                    both on our websites and third-party websites participating in the ad networks. This process also
                    helps us track the effectiveness of our marketing efforts and assists other websites and advertising
                    partners in finding you or people like you on different platforms, including social media
                    websites.</p>

                <h3>5. Social and General Information Tools</h3>

                <p>We use several publicly-available tools and information exchange resources, such as (but not limited
                    to) a blog and Facebook (?). Any information you provide or share while using Social and General
                    Information Tools may be read, accessed, and collected by that Site and users of that Site according
                    to their Privacy Policy.</p>

                <h3>6. Phishing</h3>

                <p>Online identity theft and account hacking, including the practice currently known as &quot;phishing,&quot;
                    are of great concern. It would be best if you always were diligent when you are being asked for your
                    account information, and you must always make sure you do that in our secure system. We will never
                    request your login or credit card information in non-secure or unsolicited communication (email,
                    phone, or otherwise.</p>

                <h3>7. Security of Information</h3>

                <p>We take commercially reasonable steps to protect the integrity and confidentiality of personally
                    identifiable health information that you may share with us. Please be aware that no security
                    measures are perfect or impenetrable, and we cannot guarantee the absolute security of your
                    information. We will do our part to protect your information, but you must also protect your data.
                    In addition, we do not control the actions of anyone with whom you or any other Platform user may
                    choose to share information. As such, you should be cautious about the access you provide to others
                    when using Platform and the data you choose to share when using Platform.</p>

                <h3>8. Service Providers</h3>

                <p>We may employ third-party companies and individuals to facilitate our Platform, perform specific
                    tasks which are related to the Platform, or provide audit, legal, operational, or other services for
                    us. These tasks include but are not limited to customer service, technical maintenance, monitoring,
                    email management and communication, database management, billing and payment processing, reporting,
                    and analytics. We will share with them only the minimum necessary information to perform their task
                    for us and only after entering into an appropriate confidentiality agreement.</p>

                <p>We may provide, or third parties may provide, links to other third-party websites, services, or
                    resources beyond our control. We make no representations or endorsements regarding the quality,
                    suitability, functionality, or legality of any third-party content to which links may be provided.
                    You hereby waive any claim you might have against us for such services. COMPANY IS NOT RESPONSIBLE
                    FOR THE CONTENT ON THE INTERNET OR WEB PAGES LOCATED OUTSIDE THE PLATFORM.</p>

                <p>Your business dealings with third parties found on or through the Platform, including payment, and
                    any other terms, conditions, warranties, or representations associated with such dealings, are
                    solely between you and such third-party. You agree that we are not responsible or liable for any
                    loss or damage incurred from such transactions, the presence of such a third party, or links to
                    third-party websites or resources on the Platform.</p>

                <h3>9. Compliance with Laws and Law Enforcement</h3>

                <p>We cooperate with government and law enforcement officials to enforce and comply with the law. We may
                    disclose information necessary or appropriate to protect the safety of the public or any person, to
                    respond to claims and legal processes (including but not limited to subpoenas), and to prevent or
                    stop an activity that may be illegal or dangerous. You should also be aware that our specialists may
                    be obliged to disclose information to law enforcement or other authorities to conform to their
                    professional and legal responsibilities. Specifically, and without limitation, you should be aware
                    that the law requires mental health professionals to disclose information and/or take action in the
                    following cases:</p>

                <ol start="1" style="margin-top:0cm" type="1">
                    <li>Reported or suspected abuse of a child or vulnerable adult.</li>
                    <li>Serious suicidal potential.</li>
                    <li>Threatened harm to another person.</li>
                    <li>Court-ordered presentation of treatment.</li>
                </ol>

                <h3>10. Changes to the Privacy Policy</h3>

                <p>We may update this privacy statement at our sole discretion. The date of the last revision of this
                    policy appears at the end of this page. We encourage you to periodically review this page for the
                    latest information on our Privacy Policy and practices. Regardless of changes to our Privacy Policy,
                    we will never use the information you submit under our current privacy notice in a new way without
                    first notifying you and giving you the option to stop using the Platform.</p>

                <h3>11. Contacting us</h3>

                <p>If you have any questions or concerns about this Privacy Policy or our privacy-related practices,
                    please get in touch with us at questions@anima.help. If you want to cooperate with us, don&#39;t
                    hesitate to contact us at cooperation@anima.help.</p>

                <a name="legal_npp" class="terms-item-link"></a>
                <h2>Notice of privacy practices</h2>

                <p>We may collect the following kinds of information when you use the Services:</p>

                <p>Information you provide directly to us. For certain activities, such as when you register, use our
                    telemedicine services, subscribe to our alerts, or contact us directly, we may collect some or all
                    of the following types of information:</p>

                <ul>
                    <li>Contact information, such as your full name, email address, and mobile phone number;</li>
                    <li>Username and password;</li>
                    <li>Payment information, such as your credit card number, expiration date, and credit card security
                        code;
                    </li>
                    <li>Personal health information;</li>
                    <li>Any other information you provide to us.</li>
                </ul>

                <p>We may combine such information with information we already have about you.</p>

                <p>Information we collect automatically. We may collect certain information automatically when you use
                    our Services, such as your Internet protocol (IP) address, device, and advertising identifiers,
                    browser type, operating system, Internet service provider, pages that you visit before and after
                    using the Services, the date and time of your visit, information about the links you click and pages
                    you view within the Services, and other standard server log information. We may also collect
                    location information when you use our Services, such as your computer&#39;s IP address, your mobile
                    device&#39;s GPS signal, or information about nearby WiFi access points and cell towers.</p>

                <p>We may use cookies, pixel tags, Local Shared Objects, and similar technologies to collect this
                    information automatically. By using the Services, you consent to our use of cookies and similar
                    technologies.</p>

                <p>We may also collect technical data to address and fix technical problems and improve our Services,
                    including the memory state of your device when a system or app crash occurs while using our
                    Services. Your device or browser settings may permit you to control the collection of this technical
                    data. This data may include parts of a document you used or the contents of your communications when
                    a problem occurred. By using the Services, you consent to collect this technical data.</p>

                <p>Information we obtain from your health care providers and other sources.</p>

                <h3>Use of information</h3>

                <p>We generally use the information we collect online to:</p>

                <ul>
                    <li>Provide and improve the Services;</li>
                    <li>Contact you;</li>
                    <li>Fulfill your requests for products, services, and information;</li>
                    <li>Send you information about additional services or general wellness from us or on behalf of our
                        affiliates and trusted third-party partners;
                    </li>
                    <li>Analyze the use of the Services and user data to understand and improve the Services;</li>
                    <li>Customize the content you see when you use the Services;</li>
                    <li>Conduct research using your information, which may be subject to your separate written
                        authorization;
                    </li>
                    <li>Prevent potentially prohibited or illegal activities and otherwise by our Terms of Use</li>
                    <li>For any other purposes disclosed when we collect your information or under your consent.</li>
                </ul>

                <h3>Sharing of information</h3>

                <p>We are committed to maintaining your trust and want you to understand when and with whom we may share
                    the information we collect.</p>

                <ul>
                    <li>Healthcare providers, insurance companies, and other healthcare-related entities. We may share
                        your information with other service providers, agencies, companies, organizations.
                    </li>
                    <li>Authorized third-party vendors and service providers. We may share your information with
                        third-party vendors and service providers that help us with specialized services, including
                        billing, payment processing, customer service, email deployment, business analytics, marketing
                        (including but not limited to advertising, attribution, mobile marketing, optimization, and
                        retargeting), performance monitoring, hosting, and data processing. These third-party vendors
                        and service providers may not use your information for purposes other than those related to the
                        services they are providing to us.
                    </li>
                    <li>Research partners. We may share your information with our research partners to conduct
                        health-related research; such sharing may be subject to your written authorization.
                    </li>
                    <li>Corporate affiliates. We may share your information with our corporate affiliates subject to
                        this policy.
                    </li>
                    <li>Business transfers. We may share your information in connection with a substantial corporate
                        transaction, such as the sale of a website, a merger, consolidation, asset sale, or in the
                        unlikely event of bankruptcy.
                    </li>
                    <li>Legal purposes. We may disclose information to respond to subpoenas, court orders, legal
                        processes, law enforcement requests, legal claims, or government inquiries, and to protect and
                        defend the rights, interests, health, safety, and security of our users, or the public. Suppose
                        we are legally compelled to disclose information about you to a third party. In that case, we
                        will attempt to notify you by sending an email to the email address in our records unless doing
                        so would violate the law or you have not provided your email address to us.
                    </li>
                    <li>With your consent or at your direction. We may share information for any other purposes
                        disclosed to you at the time we collect the information or under your consent or direction.
                    </li>
                </ul>

                <p>Outside of the use cases specified above, we will not provide your information to third parties.
                    However, third-party access services, such as Facebook or Google, through the Services to login to
                    the Services or to share information about your experience on the Services with others. These
                    third-party services may be able to collect information about you, including information about your
                    activity on the Site. They may notify your connections on the third-party services about your site
                    use under their privacy policies.</p>

                <p>If you engage in public activities on the Site or third-party sites that we link to, you should be
                    aware that any information you share there can be read, collected, or used by other users of these
                    areas. It would be best to use caution when disclosing personal information while participating on
                    these sites. We are not responsible for the data you choose to submit in these public areas.</p>

                <h3>Security</h3>

                <p>We use reasonable measures to help protect information from loss, theft, misuse, unauthorized access,
                    disclosure, alteration, and destruction. You should understand that no data storage system or data
                    transmission over the Internet or any other public network can be guaranteed 100 percent secure.
                    Please note that information collected by third parties may not have the same security protections
                    as information you submit to us, and we are not responsible for protecting the security of such
                    information.</p>

                <a name="legal_nnd" class="terms-item-link"></a>
                <h2>Notice of Nondiscrimination</h2>

                <p>Company does not discriminate and does not permit discrimination, including, without limitation,
                    bullying, abuse, or harassment, based on actual or perceived race, color, religion, national origin,
                    ancestry, age, gender, physical or mental disability, sexual orientation, gender identity or
                    expression or HIV status, or based on association with another person on account of that person&#39;s
                    actual or perceived race, color, religion, national origin, ancestry, age, gender, physical or
                    mental disability, sexual orientation, gender identity or expression or HIV status.</p>

                <p>Effective date August 21, 2022</p>

            </div>

        </div>

    </div>
</section>
<app-footer></app-footer>
